import { network } from 'services/network';

export const userForceLogout = (params) => {
    return network.post('admin/bo/userForceLogout', params).then((response) => {
        return response.data;
    });
};
